import { FC } from "react";

import { PillBannerButton } from "components/footer/PillBannerButton";
import { type PresentationBannerColorType } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";

export type MovePresentationButtonProps = {
  onClick: () => void;
  color: PresentationBannerColorType;
};

export const MovePresentationButton: FC<MovePresentationButtonProps> = ({ onClick, color }) => {
  return (
    <PillBannerButton
      eventName="Presentation - Move presentation here"
      kind={`banner-${color}`}
      onClick={onClick}
    >
      {t("main_header.move_presentation")}
    </PillBannerButton>
  );
};
